/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GrantResources} from '../models/GrantResources';

export interface GetGrantResources$Request {
    grantId: string;
    pageNumber: number;
    pageSize: number;
}

export interface GetGrantResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGrantResourcesRequest = createAction<PayloadData<void, GetGrantResources$Request>>('GRANT_RESOURCES__GET_GRANT_RESOURCES__REQUEST');
export const getGrantResourcesSuccess = createAction<PayloadData<GrantResources, GetGrantResources$Request>>('GRANT_RESOURCES__GET_GRANT_RESOURCES__SUCCESS');
export const getGrantResourcesFailure = createAction<PayloadData<Error, GetGrantResources$Request, true>>('GRANT_RESOURCES__GET_GRANT_RESOURCES__FAILURE');

export const getGrantResourcesActions = [
    getGrantResourcesRequest,
    getGrantResourcesSuccess,
    getGrantResourcesFailure
] as const;

/**
 * @param {string} meta.grantId
 * @param {number} meta.pageNumber
 * @param {number} meta.pageSize
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGrantResources = (meta: GetGrantResources$Request, config?: GetGrantResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getGrantResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/grants/${meta.grantId}/resources`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

